import React, { createContext, useContext, useState } from 'react'
import PropTypes from 'prop-types'
import { useFormContext } from 'react-hook-form'
import { useGetSelectedPageContent } from '../hooks/useGetSelectedPageContent'

const InfographicTemplateContext = createContext({})

export const PreviewDisplayProvider = ({ children, editingLevel = 'page' }) => {
  const [selectedBlockId, setSelectedBlockId] = useState(null)
  const [selectedReportObjectId, setSelectedReportObjectId] = useState(null)
  const [currentPageIndex, setCurrentPageIndex] = useState(0)
  const { watch } = useFormContext()
  const templateContent = watch('content')

  const currentPageContent = useGetSelectedPageContent(currentPageIndex, templateContent)

  const value = {
    selectedBlockId,
    setSelectedBlockId,
    selectedReportObjectId,
    setSelectedReportObjectId,
    currentPageIndex,
    setCurrentPageIndex,
    currentPageContent,
    editingLevel
  }

  return (
    <InfographicTemplateContext.Provider value={value}>
      {children}
    </InfographicTemplateContext.Provider>
  )
}

PreviewDisplayProvider.propTypes = {
  children: PropTypes.node,
  editingLevel: PropTypes.oneOf(['page', 'block'])
}

export const usePreviewDisplayContext = () => {
  const context = useContext(InfographicTemplateContext)
  if (!context) throw new Error('useInfographicTemplateContext must be used within InfographicTemplateProvider')
  return context
}
